import React, {Fragment} from 'react';
import {MapItem, StaticTextItem} from '../MapItems/MapItems';
import {Line} from 'react-chartjs-2';
import '../MapItems/MapItems.css';

function getWeekday(index) {
  const today = new Date();
  const weekdays = ['Mo', 'Di', 'Mi', 'Do', 'Fr', 'Sa', 'So'];
  return weekdays[(today.getDay() - 1 + index) % weekdays.length];
}

const InputField = ({value, callback}) => {
  const [input, setInput] = React.useState(value);

  const publicChange = () => {
    callback(parseFloat(input));
    setInput(parseFloat(input).toString());
  };
  const privateChange = e =>
    setInput(e.target.value ? e.target.value.replace(',', '.') : '');

  React.useEffect(() => {
    setInput(value.toString());
  }, [value]);

  return (
    <input
      style={{
        border: '0',
        width: '100%',
        height: '100%',
        textAlign: 'center',
        fontSize: '24px'
      }}
      type={'text'}
      className='tendency-input'
      size={3}
      value={input}
      onChange={privateChange}
      onBlur={publicChange}
      onKeyUp={e => {
        if (e.key === 'Enter') {
          publicChange();
        }
      }}
    />
  );
};

function weekdayLabel(x, y, message) {
  return (
    <StaticTextItem
      scale={0.5}
      position={{x: x, y: y}}
      backgroundColor='#AFAFAF'
      fontColor='#3C3C3C'
      size={{width: 160, height: 90}}
      message={message}
    />
  );
}

const datasetKeyProvider = () => {
  return btoa(Math.random()).substring(0, 12);
};

export function WDRLineGraph(props) {
  const item = props.item;
  const temps = item.data.temperatures.value; //array
  const mapTemps = item.data.temperatures.value.slice(5, 12);
  const l = mapTemps.length;
  const temperatures = Object.keys(item.data)[0];

  const mapData = new Array(l);
  const errorRange = new Array(l);
  const errorRangeMax = new Array(l);
  const errorRangeMin = new Array(l);

  for (const [key, value] of Object.entries(item.ui.errorRange)) {
    // console.log(`${key}: ${value.value}`);
    errorRange[key] = value.value;
  }

  for (const [index, temp] of Object.entries(temps)) {
    // console.log(`${key}: ${value.value}`);
    if (index >= 5 && index <= 11) {
      const i = index - 5;
      mapData[i] = temp.value;
      errorRangeMin[i] = temp.value - errorRange[i];
      errorRangeMax[i] = temp.value + errorRange[i];
    }
  }

  const errorMax = Math.max(...errorRange);
  const min = Math.min(...mapData) - errorMax;
  const max = Math.max(...mapData) + errorMax;

  return (
    <MapItem {...props}>
      <div
        className='linegraph-wrapper'
        style={{
          backgroundColor: item.ui.backgroundColor,
          width: '100%',
          height: '100%'
        }}>
        <Line
          options={{
            animation: false,
            maintainAspectRatio: false,
            scaleShowVerticalLines: false,
            // responsive: true,
            title: {
              display: false
            },
            layout: {
              padding: {
                left: -10,
                right: 0,
                top: 0,
                bottom: -10
              }
            },
            legend: {
              display: false
            },
            tooltips: {
              enabled: false
            },
            scales: {
              yAxes: [
                {
                  ticks: {
                    display: false,
                    max: max, //(max + errorMax),
                    min: min, //(min - errorMax),
                    stepSize: 20
                    // beginAtZero: true,
                  },
                  gridLines: {
                    display: false,
                    drawBorder: false
                  }
                }
              ],
              xAxes: [
                {
                  ticks: {display: false},
                  gridLines: {
                    display: false,
                    drawBorder: false
                  }
                }
              ]
            }
          }}
          data={{
            labels: [
              'January',
              'February',
              'March',
              'April',
              'May',
              'June',
              'July'
            ],
            datasets: [
              {
                pointRadius: 0,
                type: 'line',
                data: errorRangeMin,
                fill: '+1',
                lineTension: 0.01,
                backgroundColor: '#d2e36b',
                borderColor: 'transparent',
                borderWidth: 1,
                order: 1
              },
              {
                pointRadius: 0,
                type: 'line',
                data: errorRangeMax,
                fill: false,
                lineTension: 0.01,
                backgroundColor: '#bfd72b',
                borderColor: 'transparent',
                borderWidth: 1,
                order: 1
              },
              {
                pointRadius: 0,
                type: 'line',
                data: mapData,
                fill: false,
                lineTension: 0.01,

                borderColor: 'white',
                borderWidth: 4,
                order: 1
              }
            ]
          }}
          datasetKeyProvider={datasetKeyProvider}
        />
        <StaticTextItem
          scale={props.scale}
          position={{x: -75, y: -50}}
          backgroundColor='transparent'
          size={{width: 100, height: 100}}
          message={Math.round(min) + '°C'}
        />
        <StaticTextItem
          scale={props.scale}
          position={{x: -75, y: -420}}
          backgroundColor='transparent'
          size={{width: 100, height: 100}}
          message={Math.round(max) + '°C'}
        />

        {temps.map((el, i) => {
          if (i >= 5 && i <= 11) {
            return (
              <MapItem
                key={i}
                scale={0.5}
                position={{x: (i - 5) * (160 + 16) + 82, y: -532}}
                backgroundColor='#EDECEC'
                fontColor='#3C3C3C'
                size={{width: 160, height: 90}}>
                <InputField
                  key={i}
                  value={el.value}
                  callback={newval => {
                    let newArr = temps.slice();
                    newArr[i].value = newval;
                    props.onChange(item, {
                      [temperatures]: {
                        value: newArr
                      }
                    });
                  }}
                />
              </MapItem>
            );
          }
          return <Fragment key={i} />;
        })}

        {weekdayLabel(82, 62, getWeekday(5))}
        {weekdayLabel(258, 62, getWeekday(6))}
        {weekdayLabel(436, 62, getWeekday(7))}
        {weekdayLabel(612, 62, getWeekday(8))}
        {weekdayLabel(790, 62, getWeekday(9))}
        {weekdayLabel(966, 62, getWeekday(10))}
        {weekdayLabel(1142, 62, getWeekday(11))}
      </div>
    </MapItem>
  );
}
